<template>
  <b-card
    no-body
    class="p-2"
  >
    <h3 class="mb-2">
      {{
        hierarchicalLevel.nivelJerarquicoId == 0
          ? $t("Routes.HierarchicalLevelAdd")
          : $t("Routes.HierarchicalLevelEdit")
      }}
    </h3>
    <validation-observer
      #default="{ handleSubmit }"
      ref="refFormObserver"
    >
      <b-form
        @submit.prevent="handleSubmit(onSubmit)"
        @reset.prevent="resetForm"
      >
        <b-row>
          <!-- name work area field -->
          <b-col cols="12" md="6">
            <validation-provider
              #default="{ errors }"
              :name="$t('organizationChart.hierarchicalLevel.columns.name')"
              rules="required"
            >
              <b-form-group
                :label="$t('organizationChart.hierarchicalLevel.columns.name')"
                :state="errors.length > 0 ? false : null"
              >
                <b-form-input v-model="hierarchicalLevel.nombre" />
                <b-form-invalid-feedback
                  :state="errors.length > 0 ? false : null"
                >
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" md="6">
            <validation-provider
              #default="{ errors }"
              :name="$t('organizationChart.hierarchicalLevel.columns.order')"
            >
              <b-form-group
                :label="$t('organizationChart.hierarchicalLevel.columns.order')"
                :state="errors.length > 0 ? false : null"
              >
                <b-form-input
                  v-model="hierarchicalLevel.orden"
                  type="number"
                />
                <b-form-invalid-feedback
                  :state="errors.length > 0 ? false : null"
                >
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <!-- Description Field -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="Description"
              rules="required"
            >
              <b-form-group
                :label="
                  $t('organizationChart.hierarchicalLevel.columns.description')
                "
                :state="errors.length > 0 ? false : null"
              >
                <b-form-textarea v-model="hierarchicalLevel.descripcion" />
                <b-form-invalid-feedback
                  :state="errors.length > 0 ? false : null"
                >
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row class="float-right mt-2 mb-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
          >
            <b-spinner v-if="addingHierarchicalLevel" small class="mr-1" />
            {{
              hierarchicalLevel.nivelJerarquicoId == 0
                ? $t("Lists.Add")
                : $t("Lists.Edit")
            }}
          </b-button>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BCard,
  BForm,
  BRow,
  BCol,
  BFormInput,
  BFormGroup,
  BFormTextarea,
  BSpinner,
  BFormInvalidFeedback,
  BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import organizationChart from '@/services/organizationchart.service'
import { ref } from '@vue/composition-api'
import router from '@/router'
import { required } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'

export default {
  components: {
    BCard,
    BForm,
    BRow,
    BCol,
    BFormInput,
    BFormInvalidFeedback,
    BFormGroup,
    BFormTextarea,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    modalCall: {
      type: Boolean,
      require: false,
      default: false,
    },
  },
  setup(props, { emit }) {
    const addingHierarchicalLevel = ref(false)
    const hierarchicalLevel = ref({
      nivelJerarquicoId: 0,
      nombre: '',
      descripcion: '',
      orden: null,
      archivado: false,
    })

    const blankHierarchicalLevel = {
      nivelJerarquicoId: 0,
      nombre: '',
      descripcion: '',
      orden: null,
      archivado: false,
    }

    const {
      fetchHierarchicalLevel,
      createHierarchicalLevel,
      updateHierarchicalLevel,
    } = organizationChart()

    const resetHierarchicalLevel = () => {
      hierarchicalLevel.value = JSON.parse(JSON.stringify(blankHierarchicalLevel))
    }

    if (router.currentRoute.params.nivelJerarquicoId) {
      fetchHierarchicalLevel(router.currentRoute.params.nivelJerarquicoId, data => {
        hierarchicalLevel.value = data
      })
    } else {
      hierarchicalLevel.value = JSON.parse(JSON.stringify(blankHierarchicalLevel))
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetHierarchicalLevel)

    const onSubmit = () => {
      addingHierarchicalLevel.value = true
      if (hierarchicalLevel.value.nivelJerarquicoId === 0) {
        createHierarchicalLevel(hierarchicalLevel.value, () => {
          addingHierarchicalLevel.value = false
          if (props.modalCall) {
            emit('find-records')
          } else {
            router.push({ name: 'apps-organization-chart-hierarchical-level-list' })
          }
        })
      } else {
        updateHierarchicalLevel(hierarchicalLevel.value.nivelJerarquicoId, hierarchicalLevel.value, () => {
          addingHierarchicalLevel.value = false
          router.push({ name: 'apps-organization-chart-hierarchical-level-list' })
        })
      }
    }

    return {
      hierarchicalLevel,
      addingHierarchicalLevel,
      required,
      getValidationState,
      refFormObserver,
      resetForm,
      onSubmit,

    }
  },
}
</script>
